<template>
  <span class="base-more-actions" @click.stop>
    <template v-if="isPhone">
      <button
        type="button"
        class="base-more-actions__button"
        :aria-label="$t('actions.more-actions')"
        aria-haspopup="dialog"
        @click="open = true"
      >
        <BaseIcon name="more-horizontal" aria-hidden="true" />
      </button>
      <BaseBottomSheet v-model="open" :title="title">
        <ul class="base-bottom-sheet__menu">
          <li v-for="action in actions" :key="action.key">
            <button type="button" :class="{ 'is-danger': action.danger }" @click="choose(action)">
              <BaseIcon :name="action.icon" />
              {{ action.label }}
            </button>
          </li>
        </ul>
      </BaseBottomSheet>
    </template>
    <v-menu v-else>
      <template v-slot:activator="{ on, attrs }">
        <BaseIcon name="more-horizontal" v-bind="attrs" v-on="on" />
      </template>
      <div class="base-actions-menu" :class="menuClass">
        <ul>
          <li
            v-for="action in actions"
            :key="action.key"
            :class="{ delete: action.danger }"
            @click="$emit('select', action.key)"
          >
            <BaseIcon :size="20" :name="action.icon" />
            <span>{{ action.label }}</span>
          </li>
        </ul>
      </div>
    </v-menu>
  </span>
</template>

<script>
import BaseBottomSheet from '@/components/base/BaseBottomSheet.vue';
import BaseIcon from '@/components/base/BaseIcon';
import { viewport } from '@/util/viewport';

// A row's ⋯ and its actions: a menu under it on larger screens, a sheet on phones
// (docs/page-layout.md). The row's own tap stays the row's.
export default {
  name: 'BaseMoreActions',
  components: { BaseBottomSheet, BaseIcon },
  props: {
    // `{ key, label, icon, danger? }` each.
    actions: { type: Array, required: true },
    // The sheet's title on phones: what the actions act on.
    title: { type: String, default: '' },
    // The menu's own class on larger screens, as the page styled it.
    menuClass: { type: String, default: '' },
  },
  data() {
    return { open: false };
  },
  computed: {
    isPhone() {
      return viewport.size === 'phone';
    },
  },
  methods: {
    // As in every sheet, a choice closes it first.
    choose(action) {
      this.open = false;
      this.$emit('select', action.key);
    },
  },
};
</script>

<style lang="scss">
.base-more-actions {
  display: inline-flex;
  align-items: center;

  &__button {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin: -10px -10px -10px 0;
    border-radius: $radius-full;
    color: $color-normal;

    .base-icon {
      width: 20px;
      height: 20px;
    }
  }
}

// In a phone row's corner (BasePhoneRow, BasePhoneTable), one of the row's 40px buttons.
.base-phone-row__actions .base-more-actions__button {
  width: 40px;
  height: 40px;
  margin: 0;
  color: $color-slate-500;

  .base-icon {
    width: 18px;
    height: 18px;
  }
}
</style>
